export default "__VITE_ASSET__Dhda60cc__"